"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AuthContext = _interopRequireDefault(require("./AuthContext"));

var getDisplayName = function getDisplayName(name) {
  return "WithAuth(" + name + ")";
};

function withAuth(WrappedComponent) {
  var displayName = getDisplayName(WrappedComponent.displayName || WrappedComponent.name);

  var WithAuthComponent = function WithAuthComponent(props) {
    return /*#__PURE__*/_react.default.createElement(_AuthContext.default.Consumer, null, function (authContext) {
      return /*#__PURE__*/_react.default.createElement(WrappedComponent, (0, _extends2.default)({}, props, {
        authContext: authContext
      }));
    });
  };

  WithAuthComponent.propTypes = {
    keycloak: _propTypes.default.object
  };
  WithAuthComponent.WrappedComponent = WrappedComponent;
  WithAuthComponent.displayName = displayName;
  return WithAuthComponent;
}

var _default = withAuth;
exports.default = _default;